import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';

/**
 * The `VcFundedFilter` function is a React component that renders a dropdown filter for VC funded
 * options, allowing users to select a specific option.
 * @returns a JSX element.
 */
function VcFundedFilter({ heading, VCFundedOptions, setVCFundedOptions, customPathname, isPopupOpen, setIsPopupOpen }) {
    const { VcFunded, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    
    // Use centralized state if provided, otherwise fall back to internal state
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    const handleChange = (e) => {
        const value = e.target.value
        setVCFundedOptions(VCFundedOptions?.map(type => ({ ...type, isChecked: value === "" ? false : type.value === value })))
    };

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.vcFunded?.map(value => value.value) ?? [];
        setVCFundedOptions(VcFunded?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.value) })))
    }, [VcFunded, customPathname, refineSearchFilters, setVCFundedOptions])

    const selected = VCFundedOptions?.filter(option => option.isChecked)?.at(0)

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-lg px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 w-full md:w-[90%] text-left flex items-center justify-between"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{heading} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {VCFundedOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto grid grid-cols-3">
                                <label className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="vcFunded"
                                        value=""
                                        checked={!selected}
                                        onChange={handleChange}
                                        className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                    />
                                    <span className="text-[13px] font-semibold text-black">All</span>
                                </label>
                                {VCFundedOptions?.filter(option => option.name !== "Select" && option.name !== "All")?.map(vcFund => (
                                    <label key={vcFund.name} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                        <input
                                            type="radio"
                                            name="vcFunded"
                                            value={vcFund.value}
                                            checked={selected?.value === vcFund.value}
                                            onChange={handleChange}
                                            className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                        />
                                        <span className="text-[13px] font-semibold text-black">{vcFund.name}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default VcFundedFilter